const _classes = {
  "list-item": "cui-list-item-znju",
  "list-item-destructive": "cui-list-item-destructive-rt4k",
  "navigation-item": "cui-navigation-item-bhz8"
};
export {
  _classes as default
};
